module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"You get 90 days of free workspace.","close":"Close"},"th":{"title":"คุณได้รับสิทธิ์เวิร์คสเปซฟรี 90 วัน","close":"ปิด"}}')
  delete Component.options._Ctor
}
